import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/rooms/")({
  beforeLoad: async () => {
    return {
      title: "",
    };
  },
  loader: async ({ context: { queryClient } }) => {
    return {};
  },
  component: RouteComponent,
});

function RouteComponent() {
  return <div>Rooms Index</div>;
}
